import  Nave  from "./nav_4.js";

export default function Learn() {
  return (
      <div>
        <h3> ⭐️ Helpful Videos for Beginners ⭐️ </h3>
        <Nave YoutubeEmbed="/frontend"  YoutubeEmbed3="/backend" YoutubeEmbed2="/ai"/>

      </div>
    )
  }

/*
While stalking me casually perusing my portfolio, maybe you'll stumble upon something that you're interested in trying out.
Here, you will find a few walk-throughs for some of the nifty things i've come across to do in order to gain my desired skill set
*/
